<template functional>
  <div
    :style="{
      width: `${props.imageWidth}px`,
      ...props.customImagWrappeerStyle
    }"
  >
    <div
      class="image"
      :style="{
        width: `${props.imageWidth}px`,
        height: `${props.imageWidth}px`,
        borderRadius: `${props.borderRadius}px`,
        overflow: 'hidden',
        ...((props.customStyle && props.customStyle.goodImage) || {})
      }"
    >
      <component
        :is="injections.components.GoodImage"
        :img-url="props.imgUrl | ossImage(500, 500, 'contain') | ossHttpVersion"
        :width="`${props.imageWidth}px`"
        :height="`${props.imageWidth}px`"
        :fit="'cover'"
      />
      <template v-if="props.rank">
        <div :class="['rank', 'rank_' + props.skuIndex]">
          {{ props.skuIndex + 1 }}
        </div>
      </template>
      <template v-if="props.showCountdown">
        <component
          :is="injections.components.CountDown"
          :remain-time="props.remainTime"
          :remain-title="props.remainTitle"
        />
      </template>

      <component
        :is="injections.components.GoodImgTag"
        :sku-img="props.skuImg"
        :custom-imag-style="props.customStyle"
      />
    </div>
    <div
      v-if="props.bottomTag"
      class="bottom-tip"
      :style="{
        color: `${props.bottomTag.textColor}`,
        backgroundColor: `${props.bottomTag.backgroundColor}`
      }"
    >
      {{ props.bottomTag.tag }}
    </div>
  </div>
</template>

<script>
import GoodImgTag from '../skuImgTag'
import CountDown from '../countDown'
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  inject: {
    components: {
      default: {
        GoodImgTag,
        GoodImage,
        CountDown
      }
    }
  },
  props: {
    remainTime: {
      type: [String, Number],
      default: ''
    },
    remainTitle: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    rank: {
      type: Boolean,
      default: false
    },
    showCountdown: {
      type: Boolean,
      default: false
    },
    skuIndex: {
      type: [String, Number],
      default: ''
    },
    imageWidth: {
      type: Number,
      default: 0
    },
    promoteTagPic: {
      type: Array,
      default: () => []
    },
    stockStatus: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    layoutType: {
      type: String,
      default: ''
    },
    billionTip: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    customImagWrappeerStyle: {
      type: Object,
      default: () => {}
    },
    skuImg: {
      type: Object,
      default: () => {}
    },
    bottomTag: {
      type: Object,
      default: null
    },
    borderRadius: {
      type: [Number, String],
      default: 6
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: rgba(255, 255, 255, 0.6);
}
.rank {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  width: 30px;
  height: 37px;
  background-image: url('~@/images/goods_rank/top4.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 13px;
  box-sizing: border-box;
  @include text(14px, #ffffff, true);
  &.rank_0 {
    background-image: url('~@/images/goods_rank/top1.png');
  }
  &.rank_1 {
    background-image: url('~@/images/goods_rank/top2.png');
  }
  &.rank_2 {
    background-image: url('~@/images/goods_rank/top3.png');
  }
}
.bottom-tip {
  position: relative;
  top: -0.16rem;

  padding-top: 0.22rem;
  padding-bottom: 0.06rem;

  border-radius: 0 0 0.12rem /* 6/50 */ 0.12rem;

  text-align: center;

  @include text(0.2rem, #fff);
}
.image {
  position: relative;
  z-index: 1;
  flex: none;
}
</style>
